/**
 * dir-w | backOffice
 * Service to save, remove, and get data from local storage as JSON data.
 * - save
 * - remove
 * - get
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  constructor() {}

  /**
   * Save to local storage with specified key
   * @param _key
   * @param _data
   */
  public static save(_key: string, _data: any): void {
    localStorage.setItem(_key, JSON.stringify(_data));
  }

  /**
   * Remove from local storage based on specified key
   * @param _key string
   */
  public static remove(_key: string): void {
    localStorage.removeItem(_key);
  }

  /**
   * Get data from local storage, and return it as JSON
   * @param _key string
   * @returns `any`
   */
  public static get(_key: string): any {
    return JSON.parse(localStorage.getItem(_key) || '{}');
  }
}
